<template>
  <div class="AssetCategoryConfig">
    <el-main class="p-0">  
      <el-form ref="form"
        label-width="90px"
        class="form-label-90"
        :rules="rules"
        :model="data"
      >  
        <el-row>
          <el-col :span="24">
            <el-form-item label="수금 계정" prop="collect">
              <el-select v-model="collect_parent_id">
                <el-option
                  v-for="item in incomeParentItems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-select v-model="data.collect" class="pl-default">
                <el-option
                  v-for="item in collectItems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>    
        <el-row>
          <el-col :span="24">
            <el-form-item label="지출 계정" prop="pay">
              <el-select v-model="pay_parent_id">
                <el-option
                  v-for="item in expenseParentItems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-select v-model="data.pay" class="pl-default">
                <el-option
                  v-for="item in payItems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="A/S 계정" prop="pay">
              <el-select v-model="service_parent_id">
                <el-option
                  v-for="item in incomeParentItems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-select v-model="data.service" class="pl-default">
                <el-option
                  v-for="item in serviceItems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>    
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="handleClickSave"
        @click="handleClickSave"
      >{{ $t("button.save") }}(F4)</el-button>
    </el-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AssetCategoryConfig",
  data() {
    return {
      title: this.$t("title.asset_category"),
      data: {},
      rules: {
        collect: [{ required: true, message: "수금 계정을 선택하세요" }],
        pay: [{ required: true, message: "지출 계정을 선택하세요" }],
        service: [{ required: true, message: "A/S 계정을 선택하세요" }],
      },
      collect_parent_id: null,
      pay_parent_id: null,
      service_parent_id: null,      
    }
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_config", "table_asset_category"]),    
    incomeParentItems() {
      return this.table_asset_category.filter(
        c => c.use_flag === 'Y' && c.type_id === 1 && !c.parent_id)
    },
    expenseParentItems() {
      return this.table_asset_category.filter(
        c => c.use_flag === 'Y' && c.type_id === 2 && !c.parent_id)
    },
    collectItems() {
      return this.table_asset_category.filter(
        c => c.use_flag === 'Y' && c.parent_id === this.collect_parent_id)
    },
    payItems() {
      return this.table_asset_category.filter(
        c => c.use_flag === 'Y' && c.parent_id === this.pay_parent_id)
    },
    serviceItems() {
      return this.table_asset_category.filter(
        c => c.use_flag === 'Y' && c.parent_id === this.service_parent_id)
    },
  },
  mounted() {
    let item = this.table_config.find(c => c.key === 'asset_category');
    this.data = item ? Object.assign({}, item.value) : {}
    let parent_collect = this.table_asset_category.find(c => c.id === this.data.collect);
    if (parent_collect) {
      this.collect_parent_id = parent_collect.parent_id;
    }
    let parent_pay = this.table_asset_category.find(c => c.id === this.data.pay);
    if (parent_pay) {
      this.pay_parent_id = parent_pay.parent_id;
    }
    let parent_service = this.table_asset_category.find(c => c.id === this.data.service);
    if (parent_service) {
      this.service_parent_id = parent_service.parent_id;
    }
  },
  methods: {
    doSave() {
      let data ={
        key: 'asset_category',
        value: this.data
      };
      this.api.updateConfig(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, '저장되었습니다.');
      });
    },
    handleClickSave() {
      if (!this.has_grant_write) { return; }
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.doSave();
      });
    },
  },
}
</script>
